const ChevronIcon = ({ isCollapsed }) => (
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`tw:transition-transform tw:duration-200 ${isCollapsed ? 'tw:-rotate-90' : ''}`}
    >
        <path
            d="M6 9.5L12 15.5L18 9.5"
            stroke="#3871FF"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default ChevronIcon
